<div class="templateBody">
  <div>
    <a [routerLink]="['/news']" class="link">News</a>
  </div>
  <div class="textDisplay" *ngIf="news" [innerHTML]="news.value"></div>
  <div>
    <a [routerLink]="['/news']">Read more</a>
  </div>  
  <div style="margin-top: 20px;">
    <p class="link">Airport User Instructions</p>
    <p>This document contains instructions for an Airport user for the web based Filter Tool.</p>
    <span><b>File: </b></span>
    <a href="../../assets/files/Instructions for the Airport Contact.pdf"
      download="Instructions for the Airport Contact.pdf" role="menuitem">
      Instructions for the Airport Contact.pdf</a>
  </div>
  <div style="margin-top: 20px;">
    <p class="link">Filter Tool User Guide</p>
    <p>This is the general user guide for the web based Filter Tool.</p>
    <span><b>File: </b></span>
    <a href="../../assets/files/Filter Tool User Guide Final.pdf" download="Filter Tool User Guide Final.pdf"
      role="menuitem">
      Filter Tool User Guide Final.pdf</a>
  </div>
</div>